// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LifeInsuranceStep_IntegrationInsuranceFragment = { __typename?: 'IntegrationInsurance', id: string, integrationID: string, name: string, kind: Types.IntegrationInsuranceKind, externalKind: Types.IntegrationInsuranceExternalKind, value?: CurrencyUSD | null, cashValue?: CurrencyUSD | null, ownerName?: string | null, policyHolderName?: string | null, policyNumber?: string | null, policyType?: string | null, premiumAmount?: CurrencyUSD | null, startDate?: Time | null, termDurationYears?: number | null, integrationClient?: { __typename?: 'IntegrationClient', id: string, kind: Types.IntegrationClientKind } | null };

export type LifeInsuranceStepIntegrationInsurancesQueryVariables = Types.Exact<{
  householdsLike: Types.HouseholdWhereInput;
  integrationClientKind?: Types.InputMaybe<Types.IntegrationClientKind>;
}>;


export type LifeInsuranceStepIntegrationInsurancesQuery = { __typename?: 'Query', integrationInsurances: { __typename?: 'IntegrationInsuranceConnection', edges?: Array<{ __typename?: 'IntegrationInsuranceEdge', node?: (
        { __typename?: 'IntegrationInsurance' }
        & LifeInsuranceStep_IntegrationInsuranceFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    LifeInsuranceStepIntegrationInsurances: 'LifeInsuranceStepIntegrationInsurances' as const
  },
  Fragment: {
    LifeInsuranceStep_IntegrationInsurance: 'LifeInsuranceStep_IntegrationInsurance' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const LifeInsuranceStep_IntegrationInsuranceFragmentDoc = gql`
    fragment LifeInsuranceStep_IntegrationInsurance on IntegrationInsurance {
  id
  integrationID
  name
  kind
  externalKind
  value
  cashValue
  ownerName
  policyHolderName
  policyNumber
  policyType
  premiumAmount
  startDate
  termDurationYears
  integrationClient {
    id
    kind
  }
}
    `;
export const LifeInsuranceStepIntegrationInsurancesDocument = gql`
    query LifeInsuranceStepIntegrationInsurances($householdsLike: HouseholdWhereInput!, $integrationClientKind: IntegrationClientKind) {
  integrationInsurances(
    where: {and: [{hasInsurancePolicies: false}, {hasIntegrationClientWith: [{kind: $integrationClientKind}, {hasClientHouseholdsWith: [$householdsLike]}]}]}
    orderBy: {direction: DESC, field: created_at}
  ) {
    edges {
      node {
        ...LifeInsuranceStep_IntegrationInsurance
      }
    }
  }
}
    ${LifeInsuranceStep_IntegrationInsuranceFragmentDoc}`;

/**
 * __useLifeInsuranceStepIntegrationInsurancesQuery__
 *
 * To run a query within a React component, call `useLifeInsuranceStepIntegrationInsurancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLifeInsuranceStepIntegrationInsurancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLifeInsuranceStepIntegrationInsurancesQuery({
 *   variables: {
 *      householdsLike: // value for 'householdsLike'
 *      integrationClientKind: // value for 'integrationClientKind'
 *   },
 * });
 */
export function useLifeInsuranceStepIntegrationInsurancesQuery(baseOptions: Apollo.QueryHookOptions<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>(LifeInsuranceStepIntegrationInsurancesDocument, withFetchPolicyContext(options));
      }
export function useLifeInsuranceStepIntegrationInsurancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>(LifeInsuranceStepIntegrationInsurancesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLifeInsuranceStepIntegrationInsurancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>(LifeInsuranceStepIntegrationInsurancesDocument, withFetchPolicyContext(options));
        }
export type LifeInsuranceStepIntegrationInsurancesQueryHookResult = ReturnType<typeof useLifeInsuranceStepIntegrationInsurancesQuery>;
export type LifeInsuranceStepIntegrationInsurancesLazyQueryHookResult = ReturnType<typeof useLifeInsuranceStepIntegrationInsurancesLazyQuery>;
export type LifeInsuranceStepIntegrationInsurancesSuspenseQueryHookResult = ReturnType<typeof useLifeInsuranceStepIntegrationInsurancesSuspenseQuery>;
export type LifeInsuranceStepIntegrationInsurancesQueryResult = Apollo.QueryResult<LifeInsuranceStepIntegrationInsurancesQuery, LifeInsuranceStepIntegrationInsurancesQueryVariables>;